import { Link } from "react-router-dom";

export function Footer() {
	return (
		<footer className="footer">
			<img
				src="/footer-logo.svg"
				alt="simplywebdev footer-logo"
				className="footer-logo"
			/>
			<div className="footer-main">
				<div className="footer__contact column-centre">
					<span className="footer__contact-text">Contact us</span>
					<span className="footer__contact-number">+91 9359118747</span>
				</div>
				<div className="footer__form column-centre">
					<h2 className="footer__heading">
						Start your learning journey today!
					</h2>
					<p className="footer__desc">
						We will help you unlock new skills to reach your goals
					</p>

					<form action="#" className="footer__search">
						<input
							type="text"
							className="footer__input"
							placeholder="Email Address"
						/>
						<a href="#">
							<button className="footer__input-button btn--blue ">
								Get Started
								<img
									src="/up icon.svg"
									alt="simplywebdev footer up icon"
									className="footer__search__icon"
								/>
							</button>
						</a>
					</form>
				</div>
				<div className="footer__social column-centre">
					Social Media
					<div className="footer__social__links">
						<a
							href="https://www.instagram.com/simply_webdev?utm_source=qr&igsh=c3EyamduMTIxZXZx"
							target="_blank"
							rel="noopener noreferrer"
							className="footer__social__link"
						>
							<img
								src="/instagram-logo.svg"
								alt="simplywebdev instagram-logo"
							/>
						</a>
						<a
							href="https://wa.me/919359118747?text=I%20want%20to%20enroll%20in%20your%20course"
							target="_blank"
							rel="noopener noreferrer"
							className="footer__social__link-w"
						>
							<img src="/whatsapp-logo.svg" alt="simplywebdev whatsapp-logo" />
						</a>
						<a
							href="https://www.linkedin.com/in/soham-wani-mernstack-uiux-productdesigner/"
							target="_blank"
							rel="noopener noreferrer"
							className="footer__social__link"
						>
							<img src="/linkedin-logo.svg" alt="simplywebdev linkedin-logo" />
						</a>
					</div>
				</div>
			</div>
			<div className="footer__foot-nav">
				<img src="/logo.svg" alt="simplywebdev_logo" className="footer__logo" />
				<div className="footer__foot-nav__nav">
					<span className="footer__foot-nav__links">
						<a href="#courses">Courses</a>
					</span>
					<span className="footer__foot-nav__links">
						<a href="#">About us</a>
					</span>
					<span className="footer__foot-nav__links">
						<a href="#">Contact</a>
					</span>
				</div>
			</div>

			<div className="footer__credits">
				Copyright &copy; {new Date().getFullYear()} SimplyWebDev. All Rights
				Reserved.{" "}
			</div>
		</footer>
	);
}
